import { Check } from 'lucide-react'
import { toast } from 'sonner'

/**
 * The ink "Saved to … · pinned  Undo" toast from design 20b. Plain toast (not
 * success) so it keeps the ink surface rather than the rich green.
 */
export function showViewToast(message: string, undoLabel: string, onUndo: () => void) {
  toast(message, {
    icon: <Check className="size-4" aria-hidden />,
    className: 'bg-foreground! text-background! border-foreground! shadow-lg!',
    classNames: {
      actionButton: 'bg-transparent! text-background! font-semibold! text-[13px]!',
    },
    action: { label: undoLabel, onClick: onUndo },
  })
}
